import { render, staticRenderFns } from "./CaseSelector.vue?vue&type=template&id=097254c0&scoped=true"
import script from "./CaseSelector.vue?vue&type=script&lang=js"
export * from "./CaseSelector.vue?vue&type=script&lang=js"
import style0 from "./CaseSelector.vue?vue&type=style&index=0&id=097254c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097254c0",
  null
  
)

export default component.exports